const rtiMenuItems = [
  {
    id: "right-to-information-act",
    label: "Right to Information Act",
    path: "/right-to-information/right-to-information-act",
  },
  {
    id: "parliament-question-answers",
    label: "Parliament Question & Answers",
    path: "/right-to-information/parliament-question-answers",
  },
];

export const rtiSubSections = [
  {
    id: "chapter-2",
    label:
      "Chapter 2: Organisation structure, functions and duties [SECTION 4(1)(B)(i)]",
    parentId: "right-to-information-act",
    path: "/right-to-information/chapter-2",
  },
  {
    id: "chapter-4",
    label:
      "Chapter 4: Rules, Regulations, Instruction Manuals and records for discharging functions [SECTION 4(1)(B)(v)]",
    parentId: "right-to-information-act",
    path: "/right-to-information/chapter-4",
  },
  {
    id: "chapter-10",
    label:
      "Chapter 10: Directory of officers and employees [SECTION 4(1)(B)(ix)]",
    parentId: "right-to-information-act",
    path: "/right-to-information/chapter-10",
  },
  {
    id: "chapter-12",
    label:
      "Chapter 12: Budget allocated, plans, proposed expenditures and reports on disbursement made [SECTION 4(1)(B)(xi)]",
    parentId: "right-to-information-act",
    path: "/right-to-information/chapter-12",
  },
  {
    id: "chapter-13",
    label:
      "Chapter 13: Manner of execution of subsidy programmes [SECTION 4(1)(B)(xii)]",
    parentId: "right-to-information-act",
    path: "/right-to-information/chapter-13",
  },
  {
    id: "chapter-18",
    label: "Chapter 18: Details of Contract",
    parentId: "right-to-information-act",
    path: "/right-to-information/chapter-18",
  },
  {
    id: "rajya-sabha",
    label: "Rajya Sabha",
    parentId: "parliament-question-answers",
    path: "/right-to-information/rajya-sabha",
  },
  {
    id: "lok-sabha",
    label: "Lok Sabha",
    parentId: "parliament-question-answers",
    path: "/right-to-information/lok-sabha",
  },
];

export const rtiSections = [...rtiMenuItems, ...rtiSubSections];

export const normalizeRtiSection = (section) => {
  const matchedSection = rtiSections.find((item) => item.id === section);
  return matchedSection ? matchedSection.id : rtiMenuItems[0].id;
};

export const getRtiSection = (section) =>
  rtiSections.find((item) => item.id === section) || rtiMenuItems[0];

export const getRtiMenuSectionId = (section) => {
  const currentSection = getRtiSection(section);
  return currentSection.parentId || currentSection.id;
};

export default rtiMenuItems;
